import { JsonObject, JsonProperty } from 'json2typescript';

export class SignupUser {
    name: string;
    email: string;
    password: string;
    confirmPassword: string;
    phone: string;
    dob: Date;
    termsAccepted: boolean;
}

export class LoginUser {
    username: string;
    password: string;
    provider: number;
}

@JsonObject('UserSetting')
export class UserSetting {
    @JsonProperty('name', String)
    name = '';

    @JsonProperty('username', String)
    username = '';

    @JsonProperty('email', String)
    email = '';

    @JsonProperty('phone_number', String, true)
    phone = '';

}

@JsonObject('UserPassword')
export class UserPassword {
    @JsonProperty('old_password', String, true)
    oldPassword: string;

    @JsonProperty('new_password', String, true)
    newPassword: string;

    confirmPasword: string;


}
